module.exports = __webpack_public_path__ + "static/chart-21b81e5c51dec7895d5482de813b4889.png";